function CallIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      fill="#A8ADB2"
      {...props}
    >
      <path d="M15.45 12.878a6.357 6.357 0 01-1.961-.311.543.543 0 00-.561.133l-.872 1.094c-1.573-.75-3.045-2.166-3.828-3.794l1.083-.922a.567.567 0 00.133-.567 6.196 6.196 0 01-.31-1.961c0-.3-.25-.55-.55-.55H6.66c-.3 0-.661.133-.661.55C6 11.711 10.294 16 15.45 16c.394 0 .55-.35.55-.656v-1.916c0-.3-.25-.55-.55-.55z" />
    </svg>
  )
}

export default CallIcon
